import { DeleteCustomerOutDto, DeleteCustomerInDto } from '../../../types/customer.dto'

export const DELETE_CUSTOMER = 'DELETE_CUSTOMER'
export const DELETE_CUSTOMER_SUCCESS = 'DELETE_CUSTOMER_SUCCESS'
export const DELETE_CUSTOMER_ERROR = 'DELETE_CUSTOMER_ERROR'
export const RESET_DELETE_CUSTOMER = 'RESET_DELETE_CUSTOMER'

export interface DeleteCustomer {
  type: typeof DELETE_CUSTOMER
  payload: DeleteCustomerOutDto
}

export interface DeleteCustomerSuccess {
  type: typeof DELETE_CUSTOMER_SUCCESS
  payload: DeleteCustomerInDto
}

export interface DeleteCustomerError {
  type: typeof DELETE_CUSTOMER_ERROR
  payload: string | boolean
}

export interface ResetDeleteCustomer {
  type: typeof RESET_DELETE_CUSTOMER
  payload: null
}

export interface State {
  data: DeleteCustomerInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = DeleteCustomer | DeleteCustomerSuccess | DeleteCustomerError | ResetDeleteCustomer
